import { Typography } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { Column, Titration } from "src/api/types";
import { Paths } from "src/constants/paths";

export const useColumns = (): Column<Titration>[] => {
  const { pathname } = useLocation();

  return [
    {
      id: "tier",
      label: "Tier",
      align: "center",
      orderable: false,
      minWidth: 80,
      format: (row) => row.tier.toString(),
      render: (row) =>
        pathname.includes(Paths.TITRATIONS_MANAGEMENT.split("?")[0]) ? (
          <Link to={`${row.id}`}>
            <Typography>{row.tier}</Typography>
          </Link>
        ) : (
          <Typography>{row.tier}</Typography>
        ),
    },
    {
      id: "price_amount",
      label: "Price",
      align: "center",
      orderable: false,
      minWidth: 80,
      format: (row) => row.price?.amount.toString() ?? "N/A",
      render: (row) => {
        if (row.price == null) {
          return "N/A";
        }

        return <Typography>{`$${row.price?.amount.toFixed(2)}`}</Typography>;
      },
    },

    {
      id: "min_dose",
      label: "Min dose",
      align: "center",
      orderable: false,
      minWidth: 80,
      format: (row) => {
        if (row.min_dose == null) return "N/A";

        return row.min_dose.toString();
      },
      render: (row) => {
        if (row.min_dose == null) return "N/A";

        return <Typography>{`${row.min_dose} ${row.dose_unit}`}</Typography>;
      },
    },
    {
      id: "max_dose",
      label: "Max dose",
      align: "center",
      orderable: false,
      minWidth: 80,
      format: (row) => {
        if (row.max_dose == null) return "N/A";

        return row.max_dose.toString();
      },
      render: (row) => {
        if (row.max_dose == null) return "N/A";

        return <Typography>{`${row.max_dose} ${row.dose_unit}`}</Typography>;
      },
    },
    {
      id: "total_dose",
      label: "Total dose",
      align: "center",
      orderable: false,
      minWidth: 80,
      format: (row) => row.total_dose.toString(),
      render: (row) => (
        <Typography>{`${row.total_dose} ${row.dose_unit}`}</Typography>
      ),
    },
    {
      id: "slug",
      label: "Slug",
      align: "center",
      orderable: false,
      minWidth: 80,
      format: (row) => {
        if (row.slug == null) return "N/A";

        return row.slug;
      },
      render: (row) => {
        if (row.slug == null) return "N/A";

        return <Typography>{row.slug}</Typography>;
      },
    },
  ];
};
